import type { ReactNode } from 'react';

export type SummaryCardColor = 'blue' | 'green' | 'yellow' | 'purple';

interface SummaryCardProps {
  icon: ReactNode;
  label: string;
  value: string;
  color: SummaryCardColor;
}

const colorClasses: Record<SummaryCardColor, string> = {
  blue: 'bg-blue-500/20 text-blue-400',
  green: 'bg-green-500/20 text-green-400',
  yellow: 'bg-yellow-500/20 text-yellow-400',
  purple: 'bg-purple-500/20 text-purple-400',
};

/**
 * サマリーカードコンポーネント
 */
export function SummaryCard({ icon, label, value, color }: SummaryCardProps) {
  return (
    <div className="bg-card rounded-xl p-6 border border-border">
      <div className="flex items-center gap-4">
        <div className={`p-3 rounded-lg ${colorClasses[color]}`}>{icon}</div>
        <div>
          <p className="text-muted-foreground text-sm">{label}</p>
          <p className="text-2xl font-bold text-foreground">{value}</p>
        </div>
      </div>
    </div>
  );
}
